import type { Language } from '~/types'

import { mapToUiLanguage } from '~/utils/api/language'

const DEFAULT_LANGUAGE = 'en-GB' satisfies Language

export default createSharedComposable(() => {
  const { $i18n } = useNuxtApp()
  const availableLocales = $i18n.availableLocales

  const languages = computed(() => availableLocales)

  const preferredLanguages = usePreferredLanguages()
  const browserLanguage = languages.value.find(
    l => preferredLanguages.value.find(pl => pl.includes(l)),
  )

  const queryLanguageParam = mapToUiLanguage(((new URLSearchParams(location.search)).get('language') ?? '') as App.Internals.Enums.Language)
  const queryLanguage = languages.value.find(l => queryLanguageParam === l)

  const cookieLanguageParts = useCookie('docue_country').value?.split('-')
  const cookieLanguage = languages.value.find((l) => {
    if (cookieLanguageParts?.[0]?.startsWith('en'))
      return l === 'en-GB'

    return l === cookieLanguageParts?.[0]
  })

  const rawStoredLanguage = useLocalStorage('locale', null).value
  const storedLanguage = (rawStoredLanguage ? mapToUiLanguage(rawStoredLanguage as App.Internals.Enums.Language) : null)
  const storageLanguage = languages.value.find(l => storedLanguage === l)

  const language = useState<Language>(
    'language',
    () => storageLanguage || queryLanguage || cookieLanguage || browserLanguage || DEFAULT_LANGUAGE,
  )

  const { setLocale } = useNuxtApp().$i18n
  watch(language, (l) => {
    setLocale(l)
    useLocalStorage('locale', l).value = l
  }, { immediate: true })

  return { language, languages }
})
